module.exports = __webpack_public_path__ + "static/media/13-apr17dec18.3163d62e.pdf";